import { useSelector } from 'react-redux'
import props from '../../../redux/props'
import MediumContainer from '../../UI/Container/MediumContainer'
import { crud } from '@think-internet/zeus-frontend-package'
import { useCallback, useEffect, useState } from 'react'
import DirectFileUpload, { OnCallbackFile, UPLOAD_TYPES } from '../../UI/DirectFileUpload/DirectFileUpload'
import upload from '../../../assets/image/generic/upload.png'
import Carousel from '../../UI/Carousel/Carousel'
import { TrashIcon } from '@heroicons/react/24/outline'
import { s3PublicStoragePrefix } from '../../../utility'

type BannerImage = {
  uuid: string
  imageKey: string
}

const BannerImages = () => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const bannerImageFeature = crud.use(props.BANNER_IMAGE)
  const [bannerImages, setBannerImages] = useState<BannerImage[]>()

  const pull = useCallback(async () => {
    const values = await bannerImageFeature.list({})
    setBannerImages(values)
  }, [bannerImageFeature])

  useEffect(() => {
    if (!bannerImages) pull()
  }, [bannerImages, pull])

  const onImage = async (files: OnCallbackFile[]) => {
    const createdImages: BannerImage[] = []
    for (const file of files) {
      const createdImage = await bannerImageFeature.create({
        imageKey: file.key,
      })
      if (createdImage) {
        createdImages.push(createdImage)
      }
    }
    setBannerImages([...bannerImages, ...createdImages])
  }

  const remove = (uuid: string) => async () => {
    await bannerImageFeature.remove({
      uuid,
    })
    pull()
  }

  return (
    <MediumContainer>
      <div className="py-10">
        <div className="text-lg font-bold">{t.admin.bannerImages.title}</div>
        <div className="mt-3">
          <DirectFileUpload
            uploadType={UPLOAD_TYPES.BANNER_IMAGE}
            acceptedMimeTypes={['image/*']}
            onFilesCallback={onImage}
            multiple
            radialProgressBar
          >
            <img src={upload} className="h-7 hover:scale-105 transition-all" alt={t.generic.upload} />
          </DirectFileUpload>
          {bannerImages && bannerImages.length > 0 && (
            <Carousel
              smallArrows
              itemsToShow={4}
              className="mt-5"
              items={bannerImages.map((bannerImage: BannerImage, i: number) => (
                <div
                  key={bannerImage.uuid}
                  className="relative aspect-video w-full items-center justify-center bg-center bg-cover bg-no-repeat rounded-md cursor-pointer border border-gray-secondary"
                  style={{ backgroundImage: `url(${s3PublicStoragePrefix}${bannerImage.imageKey})` }}
                >
                  <div
                    className="backdrop-blur-sm rounded-sm border py-1 px-2 border-white cursor-pointer group w-fit absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                    onClick={remove(bannerImage.uuid)}
                  >
                    <TrashIcon className="h-5 fill-white group-hover:fill-magenta-primary" />
                  </div>
                  {/* <div className="hidden md:block absolute opacity-0 hover:bg-white hover:bg-opacity-25 hover:opacity-100 hover:flex h-full w-full cursor-pointer items-center justify-center">
                <TrashIcon className="w-8 text-white hover:scale-105 transition-all" onClick={() => remove(i)} />
              </div> */}
                </div>
              ))}
            />
          )}
        </div>
      </div>
    </MediumContainer>
  )
}

export default BannerImages
